import { Button, Popconfirm } from 'antd'
import { formatQueryParams } from '../../../modules/Utils'
import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import DateCell from '../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import SumFooter from '../../../elements/Table/Footers/SumFooter'
import { compose, withState } from 'recompose'
import { Link, withRouter } from 'react-router-dom'

RequisitionsList.propTypes = {}
const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/requisitions/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'Company',
    accessor: 'company.fn',
    hideable: true,
    hideDefault: true
  },
  {
    Header: 'Title',
    accessor: 'title',
  },
  {
    Header: 'Requested By',
    accessor: 'owner.fn',
  },
  {
    Header: 'Amount',
    accessor: 'converted',
    Cell: MoneyCell,
    Footer: SumFooter,
  },
  {
    Header: 'Date',
    accessor: 'date',
    Cell: DateCell,
  },
  { Header: 'Status', accessor: 'status', Cell: StatusCell },
]

function RequisitionsList(props) {
  const { reqs, fetchingReqs, fetchReqs, saleOrderID } = props

  const NewBookingButton = withRouter(({ history, ...rest }) => {
    return (
      <Popconfirm
        placement="left"
        title={`Sales Order Need to be Approved!`}
        onConfirm={() => {
          history.push({
            pathname: '/purchasing/requisitions/new',
            search: formatQueryParams('saleOrderID', saleOrderID, true),
          })
        }}
        okText="It's Approved"
        cancelText="Cancel">
        <Button type="primary" icon={'plus'} size={'small'} {...rest}>
          Requisitions
        </Button>
      </Popconfirm>
    )
  })
  return (
    <CustomTable
      columns={columns}
      data={reqs}
      fetch={fetchReqs}
      fetching={fetchingReqs}
      CreateButton={() => <NewBookingButton style={{ marginRight: 10 }} />}
    />
  )
}

RequisitionsList.propTypes = {}
RequisitionsList.defaultProps = {
  fetching: false,
  fetch: () => console.error('Not Implemented'),
  list: [],
}

export default compose(withState('filterable', 'setFilterable', true))(RequisitionsList)
